<template>
    <aside id="popup-add-policy-to-compliance" class="layout-popup mfp-hide">
        <h2 class="layout-popup-title">
            {{ $t('COMMON.BUTTON.CAMEL.ADD')}}<!--추가-->
        </h2>

        <div class="layout-popup-contents">
            <p>{{ $t('POLICY.ADD_POPUP.DESC')}} <!--정책을 검사 목록에 추가하시겠습니까?--></p>
            <fieldset class="forms">
                <legend>{{ $t('POLICY.ADD_POPUP.SELECT_ASSESSMENT_TYPE')}}</legend>
                <div class="form-item">
                    <input type="checkbox" id="right-now" name="right-now" class="checkbox" v-model="doCmpl">
                    <label for="right-now">{{ $t('POLICY.ADD_POPUP.COMPLIANCE_IMMEDIATELY')}}<!--검사를 바로 진행합니다. --></label>
                </div>
                <div class="form-item">
                    <input type="checkbox" id="set-schedule" name="set-schedule" class="checkbox" v-model="isSchedule">
                    <label for="set-schedule">{{ $t('POLICY.ADD_POPUP.CREATE_SCHEDULE')}}<!--스케줄을 설정하여 검사를 일정 시간마다 진행합니다.--></label>
                </div>
            </fieldset>

            <schedule v-if="isSchedule" ref="commonSchedule"></schedule>
        </div>

        <div class="layout-popup-footer">
            <p class="btns">
                <button type="button" class="buttons" data-size="popup" v-on:click="closePopup()">{{ $t('COMMON.BUTTON.CAMEL.CANCEL')}}<!--취소--></button>
                <button type="button" class="buttons" data-type="key" data-size="popup" v-bind:disabled="pending ? true : null" v-on:click="fnSavePolicy()">{{ $t('COMMON.BUTTON.CAMEL.OK')}}<!--확인--></button>
            </p>
        </div>
    </aside>
</template>
<script>
    import Schedule from '../common/schedule.vue'
    export default {
        name:'popAddCmplSche',
        components:{
            Schedule
        },
        props: {
            cmpl: Object,               // Popup control 정보
            pending: Boolean            // Popup Saving Flag

        },
        data: function () {
            return {
                isSchedule: false,
                doCmpl : true,

            }
        },
        methods:{
            closePopup(){
                this.Common.closePopup();
            },
            fnSavePolicy(){

                let emitObj = {};

                emitObj.doCmpl = this.doCmpl;
                if(this.isSchedule){
                    emitObj.execType='A';

                    emitObj.scheInfo = this.$refs.commonSchedule.getSelectedValues();
                    emitObj.scheInfo.cmpnId = this.cmpl.cmpnId;
                    emitObj.scheInfo.cmplId = this.cmpl.cmplId;
                }

                this.$emit('fnSaveSchedule', emitObj);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/policy/popAddCmplSche.vue